const auth = "/auth";
const companies = "/companies";
const companyData = `${companies}/:companyId`;
const connections = `${companies}/:companyId/connections`;
const account = "/account";
const products = "/products";
const rules = "/rules";
const onboarding = "/onboarding";
const integrations = "/integrations";
const dashboard = "/dashboard";

const api = {
  auth: {
    userstate: `${auth}/userstate`,
    logout: `${auth}/logout`,
  },
  companies: {
    all: companies,
    one: `${companyData}`,
    inviteLink: `${companies}/invite`,
    connections: {
      all: connections,
      one: `${connections}/:connectionId`,
    },
    excel: {
      one: `${companyData}/data/excel`,
      download: `${companyData}/data/excel/download`,
    },
    refresh: {
      all: `${companyData}/data/all`,
    },
    history: `${companyData}/data/history`,
    profitAndLoss: `${companyData}/data/financials/profitAndLoss`,
    balanceSheet: `${companyData}/data/financials/balanceSheet`,
    activityLog: `${companyData}/reports/events`,
    enabled: "/enabled",
    accountsSummary: `${companyData}/accounts/summary/`,
  },
  users: {
    contactSales: "/users/contactSales",
  },
  clients: {
    all: "/clients/select",
  },
  log: {
    clientSelect: "/log/clientSelect",
  },
  account: {
    billingPortalSession: `${account}/billingPortalSession`,
    subscriptionStatus: `${account}/subscriptionStatus`,
  },
  products: {
    all: `${products}`,
    one: `${products}/:productId`,
  },
  rules: {
    all: `${rules}`,
    one: `${rules}/:ruleId`,
    alerts: `${rules}/alerts`,
  },
  featureStatus: "/featureStatus",
  onboarding: {
    aboutCompany: `${onboarding}/aboutCompany`,
  },
  assess: {
    account: {
      categories:
        "/data/companies/:companyId/connections/:connectionId/assess/accounts/categories",
    },
  },
  profile: {
    one: "/profile",
    masked: "/profile/masked",
    branding: `/profile/branding`,
  },
  integrations: {
    enabled: `${integrations}/:platformKey/enabled`,
    branding: `${integrations}/:platformKey/branding`,
    counts: `${integrations}/counts`,
  },
  dashboard: {
    connections: {
      report: `${dashboard}/connections/report`,
    },
    companies: {
      cumulativeCreated: `${dashboard}/companies/cumulativeCreated`,
    },
  },
  signinmessages: "/signinmessages",
  apiKeys: {
    all: "/apikeys",
    one: "/apikeys/:id(.*)",
  },
  webhooks: {
    dashboard: `/webhooksDashboard`,
  },
};

export default api;
